module.exports = __webpack_public_path__ + "static/media/arteon.05bd336d.png";